import {FC, useEffect, useRef} from 'react'
import {useDispatch} from 'react-redux'
import {useAppSelector} from '../../../../setup/redux/hooks'
import {filterDataChange, getAll} from '../redux/SchedulerRedux'
import {SimpleListModel} from '../../../shared/models/SimpleListModel'
import {KTSVG} from '../../../../_metronic/helpers/components/KTSVG'
import {Link} from 'react-router-dom'
import {useIntl} from 'react-intl'
import {ALL_KEY} from '../../../shared/constants'
import {selectSchedulerFilter} from '../redux/SchedulerRedux'
import {SchedulerStatus, SchedulerSupportedType} from '../constants'
import {SchedulerFilterModel} from '../models/SchedulerListFilterModel'
import {Button} from 'react-bootstrap'

import useDrivePicker from 'react-google-drive-picker'

interface PickerCallback {
  action: string
  docs: Array<{
    id: string
    name: string
    mimeType: string
  }>
}

type Props = {
  className?: string
}
const SchedulerTableFilter: FC<Props> = () => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const schedulerFilter: SchedulerFilterModel = useAppSelector(selectSchedulerFilter)
  const handleSearchTextChanged = (e?: any | undefined) => {
    if (e) {
      const value = e.target.value
      dispatch(filterDataChange({...schedulerFilter, name: value, page: 1}))
    } else {
      dispatch(filterDataChange({...schedulerFilter, name: undefined, page: 1}))
    }
  }
  const handleSchedulerStatusChanged = (e: any) => {
    const value = e.target.value
    if (value !== '0') {
      dispatch(filterDataChange({...schedulerFilter, status: value, page: 1}))
    } else {
      dispatch(filterDataChange({...schedulerFilter, status: undefined, page: 1}))
    }
  }
  const handleFolderSupportedChanged = (e: any) => {
    const value = e.target.value
    if (value !== '0') {
      dispatch(
        filterDataChange({...schedulerFilter, folderType: value as SchedulerSupportedType, page: 1})
      )
    } else {
      dispatch(filterDataChange({...schedulerFilter, folderType: undefined, page: 1}))
    }
  }

  return (
    <div className='card-header border-0 pt-3'>
      <div className='d-flex align-items-center'>
        <div className='d-flex align-items-center position-relative me-4'>
          <span className='position-absolute cursor-pointer ms-3' onClick={handleSearchTextChanged}>
            <KTSVG path='/media/icons/duotune/general/gen021.svg' className='svg-icon-3' />
          </span>
          <input
            type='text'
            id='kt_filter_search'
            className='form-control form-control-white form-control-sm w-150px ps-9'
            placeholder='Search'
            onChange={handleSearchTextChanged}
            onKeyDown={(e: any) => {
              if (e.key === 'Enter') {
                handleSearchTextChanged()
              }
            }}
          />
        </div>
        <div className='d-flex my-2'>
          <select
            name='status'
            data-hide-search='true'
            className='form-select form-select-white form-select-sm w-125px me-4'
            defaultValue={0}
            onChange={handleSchedulerStatusChanged}
          >
            <option value={ALL_KEY}>{intl.formatMessage({id: 'SYSTEM.ALL'})}</option>
            {Object.keys(SchedulerStatus).map((item: any) => (
              <option key={item} value={item}>
                {intl.formatMessage({id: 'Scheduler.STATUS.' + item.toUpperCase()})}
              </option>
            ))}
          </select>
        </div>
        <div className='d-flex my-2'>
          <select
            name='status'
            data-hide-search='true'
            className='form-select form-select-white form-select-sm w-125px me-4'
            defaultValue={0}
            onChange={handleFolderSupportedChanged}
          >
            <option value={ALL_KEY}>{intl.formatMessage({id: 'SYSTEM.ALL'})}</option>
            {Object.keys(SchedulerSupportedType).map((item: any) => (
              <option key={item} value={item}>
                {intl.formatMessage({id: 'Scheduler.TYPE.' + item.toUpperCase()})}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className='card-toolbar'>
        <Link to={'/schedulers/create'} className='btn btn-sm btn-primary'>
          <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
          {intl.formatMessage({id: 'SYSTEM.ADD_NEW'})}
        </Link>
      </div>
    </div>
  )
}
export default SchedulerTableFilter
